document.addEventListener('DOMContentLoaded', () => {
    const mapRoot = document.querySelector('.map');
    if (!mapRoot) return;

    const scroller = mapRoot.querySelector('.map__scroller');
    if (!scroller) return;

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
    const SIDE_OFFSET = 0;

    const position = () => {
        if (!isMobile()) return;

        const crop = (scroller.dataset.crop || 'europe').toLowerCase();
        const maxLeft = scroller.scrollWidth - scroller.clientWidth;
        if (maxLeft <= 0) return;

        const scrollPos = (crop === 'usa') ? SIDE_OFFSET : (maxLeft - SIDE_OFFSET);
        scroller.scrollLeft = Math.max(0, Math.min(scrollPos, maxLeft));
    };

    position();
    window.addEventListener('resize', position, { passive: true });
    window.addEventListener('load', position);
});

document.addEventListener('DOMContentLoaded', () => {
    const mapRoot = document.querySelector('.map');
    if (!mapRoot) return;

    const track = mapRoot.querySelector('.flags-track');
    if (!track) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    let animationId = null;
    let currentX = 0;
    let shift = 0;
    const speed = 60;

    function recalc() {
        const flags = track.querySelectorAll('.flag');
        if (flags.length < 2) return;

        const half = Math.floor(flags.length / 2);
        if (!flags[half] || !flags[0]) return;

        shift = flags[half].offsetLeft - flags[0].offsetLeft;
        if (shift <= 0) return;

        if (!animationId) startAnimation();
    }

    function startAnimation() {
        let lastTime = performance.now();

        function animate(now) {
            const dt = (now - lastTime) / 1000;
            lastTime = now;

            currentX -= speed * dt;
            if (Math.abs(currentX) >= shift) currentX += shift;

            track.style.transform = `translate3d(${currentX}px,0,0)`;
            animationId = requestAnimationFrame(animate);
        }

        animationId = requestAnimationFrame(animate);
    }

    function stopAnimation() {
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
    }

    recalc();
    window.addEventListener('load', recalc);
    window.addEventListener('resize', () => { stopAnimation(); currentX = 0; recalc(); });

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAnimation();
        else if (!animationId) recalc();
    });
});
